/*
  Utility Class for handling JSON
*/
class JSONUtil {
  /*
    check if str is json
  */
  static isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}

window.JSONUtil = JSONUtil;
